module.exports = __webpack_public_path__ + "static/media/fishes-on-wall-2.65bf4045.webp";